import React from 'react'
import { FieldError } from 'react-hook-form'

import { Box, FormHelperText, OutlinedInput } from '@mui/material'

type Props = {
  id: string
  label: string
  error: FieldError
}

function InputTextField({ id, label, error, ...props }: Props, ref: React.Ref<HTMLInputElement>) {
  return (
    <>
      <FormHelperText>{label}</FormHelperText>
      <OutlinedInput fullWidth ref={ref} id={id} type="text" color="success" {...props} error={!!error} />
      <Box height={20}>
        <FormHelperText error>{error?.message}</FormHelperText>
      </Box>
    </>
  )
}

export default React.forwardRef(InputTextField)
